import React from 'react';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, TableCell, Tooltip } from '@mui/material';

type MarginWarningCellProps = {
  color: string;
  reason: string | null;
  sx: object;
  value: string;
};

// Warning cells: margin % below the minimum (red), or a non-basic package earning less gross margin
// than its basic counterpart (amber) - an upgrade should never make us less money than the base room.
export default function MarginWarningCell({ color, reason, sx, value }: MarginWarningCellProps) {
  if (!reason) {
    return (
      <TableCell align="center" sx={sx}>
        {value}
      </TableCell>
    );
  }
  return (
    <Tooltip title={reason}>
      <TableCell align="center" sx={{ ...sx, color, fontWeight: 600 }}>
        <Stack alignItems="center" direction="row" justifyContent="center" spacing={0.5}>
          <WarningAmberIcon fontSize="inherit" />
          <span>{value}</span>
        </Stack>
      </TableCell>
    </Tooltip>
  );
}
